import { useContext } from 'react';
import FreyaPopoverContext from './FreyaPopoverContext';

export const useFreyaPopover = () => useContext(FreyaPopoverContext);
